import {
  ADD_CLIENT_REPORT_CARD,
  BATCH_UPDATE_CLIENT_REPORT_CARDS,
  REMOVE_CLIENT_REPORT_CARD,
  UPDATE_CLIENT_REPORT_CARD,
  UPDATE_LISTING,
  UPDATE_PROJECT
} from 'components/project/actions';

export default function(state = {}, action) {
  let newState;

  switch (action.type) {
  case UPDATE_PROJECT: {
    newState = { ...state, ...action.payload };
    break;
  }
  case UPDATE_CLIENT_REPORT_CARD: {
    const cardData = action.payload;

    let clientReportCards = [...state.clientReportCards].map(c => c.id === cardData.id ? { ...c, ...cardData } : c);
    clientReportCards = clientReportCards.sort((a, b) => {
      return a.sortOrder - b.sortOrder;
    });

    newState = {
      ...state,
      clientReportCards
    };

    break;
  }
  case BATCH_UPDATE_CLIENT_REPORT_CARDS: {
    newState = { ...state, clientReportCards: [...action.payload] };

    break;
  }
  case UPDATE_LISTING: {
    newState = state;
    const updatedListing = action.payload;

    if (newState.listing && newState.listing.id === updatedListing.id) {
      newState = { ...newState, listing: updatedListing };
    }

    ['lotListings', 'leaseSpaceListings', 'condoListings'].forEach((listingCollectionKey) => {
      if (newState[listingCollectionKey] && newState[listingCollectionKey].length > 0) {
        const listings = newState[listingCollectionKey].map((listing) => {
          return listing.id === updatedListing.id ? updatedListing : listing;
        });
        newState = { ...newState, [listingCollectionKey]: listings };
      }
    });
    break;
  }
  case ADD_CLIENT_REPORT_CARD: {
    newState = {
      ...state,
      clientReportCards: [...state.clientReportCards, action.payload]
    };

    break;
  }
  case REMOVE_CLIENT_REPORT_CARD: {
    const { cardId } = action.payload;

    newState = {
      ...state,
      clientReportCards: [...state.clientReportCards.filter(card => card.id != cardId)]
    };
    break;
  }

  default:
    newState = state;
  }

  newState.defaultTaskAssociation = defaultTaskAssociation(newState);

  return newState;
}

function defaultTaskAssociation({ id, name }) {
  return {
    associatedModelId: id,
    associatedModelType: 'Project',
    name: name,
    default: true
  };
}
